import Repository from './Repository';
const resource = '/barista/favorite';

export default {
  getList() {
    return Repository.get(`${resource}`);
  }
};
